import checkInternalUser from '@/utils/checkInternalUser';
import { productTour } from '@/modules/productTour';

export const showProductTour = (id) => checkInternalUser(() => {
  productTour.showTour(id);
}, { allow: false });

export const setProductTourFlow = (id) => localStorage.setItem('productTourFlowId', id);

export const checkProductTourFlow = () => {
  const productTourFlowId = localStorage.getItem('productTourFlowId');
  if (productTourFlowId) {
    // Start the flow
    showProductTour(productTourFlowId);
    // Remove localStorage item
    localStorage.removeItem('productTourFlowId');
  }
};
